export const storageKeys = ['creditAppDeals', 'creditVerification', 'creditType', 'leaseTerm', 'leaseMileageRange', 'loanTerm', 'downPayment', 'downPaymentPercent', 'downPaymentType', 'interestRate', 'budget', 'dealType', 'tradeIn', 'interactions', 'monthlyBudget', 'zip', 'lastUpdated', 'createdDate', 'timeStamp', 'walletId', 'paymentOption'];

// keeping a separate list for wallet storage
export const getWalletStorageKeys = () => [...storageKeys].reduce((acc, key) => {
  if (!['previousPaymentInfo'].includes(key)) {
    acc.push(key);
  }
  return acc;
}, []);
export const buildStorageValues = _ref => {
  let {
    keys = storageKeys,
    payload
  } = _ref;
  const storageValues = keys.reduce((acc, key) => {
    const {
      downPayment,
      downPaymentPercent,
      budget,
      monthlyBudget
    } = payload;
    // There are valid cases where downPayment, downPaymentPercent, budget, or monthlyBudget should be null, other wallet values should not be null
    const downPaymentIsNull = key === 'downPayment' && downPayment === null;
    const downPaymentPercentIsNull = key === 'downPaymentPercent' && downPaymentPercent === null;
    const budgetIsNull = key === 'budget' && budget === null;
    const monthlyBudgetIsNull = key === 'monthlyBudget' && monthlyBudget === null;
    if (downPaymentIsNull || downPaymentPercentIsNull || budgetIsNull || monthlyBudgetIsNull || payload[key] != null) {
      acc[key] = payload[key];
    }
    return acc;
  }, {});
  return storageValues;
};